import {styled} from "@mui/material/styles"
import {MenuItem, FormControl, OutlinedInput} from "@mui/material"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const styles = {
    root: {
        "&&": {
            width: "100%",
            height: "2rem",
            display: "flex",
            justifyContent: "flex-start",
            padding: "0 1rem",
        },
    },
    icon: {
        minWidth: "2rem",
    },
}

export const StyledOutlinedInput = styled(OutlinedInput)`
    background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
    && {
        line-height: normal;
        font-size: inherit;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.select.large.borderRadius};
        text-transform: ${({theme}) => theme.uxfabric.component.inputText.textTransform};

        @media (min-width: ${breakpoints.values.md}px) {
            border-radius: ${({theme}) => theme.uxfabric.shape.global.select.medium.borderRadius};
            height: 2.25rem;
        }

        && > div {
            font-family: ${({theme}) =>
                `${theme.uxfabric.component.inputText.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
            font-weight: ${({theme}) => theme.uxfabric.component.inputText.fontWeight};
            font-size: ${({theme}) => theme.uxfabric.component.inputText.fontSize};
        }
    }
    &&& > fieldset {
        border: 0.0625rem solid ${({theme}) => theme.uxfabric.action.default.enabled.borderColor};
    }
`

export const SelectedFormControl = styled(FormControl)`
    &:hover {
        border: none;
    }
`

export const SelectedMenuItem = styled(MenuItem)`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem;
    transition: color 0s, background-color 0s;
    text-transform: ${({theme}) => theme.uxfabric.component.menuItem.textTransform};

    font-family: ${({theme}) => `${theme.uxfabric.component.menuItem.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;

    &.Mui-selected {
        background-color: ${({theme}) => theme.uxfabric.components.menu.default.selected.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.menu.default.selected.textColor};
        &.Mui-focusVisible {
            background-color: ${({theme}) => theme.uxfabric.components.menu.default.selected.backgroundColor};
            color: ${({theme}) => theme.uxfabric.components.menu.default.selected.textColor};
        }
    }
    &.Mui-selected:hover {
        background-color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.textColor};
    }
    &:hover {
        background-color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.textColor};
    }
`

export const StyledIcon = styled("img")`
    && {
        top: calc(50% - 0.25rem);
        right: 1rem;
    }
`
